<template>
  <v-card flat color="transparent">
    <v-card-title
      v-if="showTitle"
      class="homepageTitle font-weight-bold mb-1 px-0 text-break"
    >
      {{ eventDetails.EventTranslationName }}
    </v-card-title>

    <v-card-text class="px-0">
      <v-row
        class="px-0 px-sm-4 flex-nowrap flex-md-wrap overflow"
        justify="start"
        justify-md="center"
      >
        <ItemGroup :items="templateItems">
          <template v-slot:item="{ item }">
            <v-card flat class="pa-3 rounded-lg" outlined>
              <!-- Picture -->
              <v-img
                :src="item.PictureUrl"
                :width="imgWidth"
                aspect-ratio="1.618"
                class="mb-4 rounded"
              ></v-img>

              <!-- Title -->
              <div
                class="homepageSubTitle-md font-weight-bold mb-4 text-break px-2 item-text primary--text"
              >
                {{ item.Translations[userLanguageId].Title }}
              </div>

              <!-- Description -->
              <div
                class="mb-0 homepageDescription-md px-2 item-text text--secondary"
                v-html="
                  getChangedDescription(
                    item.Translations[userLanguageId].Description
                  )
                "
              ></div>

              <!-- Url -->
              <v-btn
                v-if="hasInfoUrl(item)"
                depressed
                color="primary"
                class="mx-2 mt-4 text-capitalize primary-font-color"
                @click="openInfoUrl(item)"
              >
                {{ $translate('VIEW') }}
                <v-icon right>arrow_right_alt</v-icon>
              </v-btn>
            </v-card>
          </template>
        </ItemGroup>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import utility from '@/shared/utility';
import ItemGroup from '@/components/generalComponents/uiComponents/ItemGroup';

export default {
  name: 'EventTemplateThree',
  props: {
    eventDetails: {
      type: Object,
      default: () => {},
    },
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ItemGroup,
  },
  computed: {
    templateItems() {
      if (
        this.eventDetails == null ||
        this.eventDetails.TemplateItems == null
      ) {
        return [];
      }

      return this.eventDetails.TemplateItems;
    },
    wrap() {
      const bp = this.$vuetify.breakpoint.name;
      if (bp === 'xs' || bp === 'sm') {
        return false;
      }
      return true;
    },
    userLanguageId() {
      let userLanguageId = 14;
      const userLanguage = this.$store.getters['auth/userLanguage'];
      if (userLanguage != null && userLanguage.LanguageId != null) {
        userLanguageId = userLanguage.LanguageId;
      }

      return userLanguageId;
    },
    imgWidth() {
      const breakPointObj = this.$vuetify.breakpoint;

      switch (breakPointObj.name) {
        case 'xl':
        case 'lg':
          return '100%';
        case 'md':
          return '100%';
        case 'sm':
          return '100%';
        default:
          return '100%';
      }
    },
  },
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {
    /**
     * function to change the description \n to <br/>
     * @param description
     * @returns {*}
     */
    getChangedDescription(description) {
      return description.replace(/\n/g, '<br />');
    },
    hasInfoUrl(item) {
      if (item != null && item.InfoUrl != null && item.InfoUrl.trim() !== '') {
        return true;
      }

      return false;
    },
    openInfoUrl(item) {
      const fullUrl = utility.getFullUrl(item.InfoUrl);
      window.open(fullUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.item-text {
  text-align: justify;
}
.overflow {
  overflow-x: auto;
}
</style>
